<forge-text-field [invalid]="isInvalid" [required]="isRequired" [ngClass]="isDense" density="small">
    <input #input type="text" [lgdNumber]="config" [formControl]="formControl" autocomplete="off">
    <label *ngIf="!hideLabel" slot="label">{{label}}</label>

    <span slot="support-text">
        <ng-container *ngIf="showErrorMessage('required')">
            {{label}} is required
        </ng-container>

        <ng-container *ngIf="showErrorMessage('pattern')">
            Value must be a number
        </ng-container>

        <ng-container *ngIf="showErrorMessage('min')">
            {{label}} cannot be less than {{min}}
        </ng-container>

        <ng-container *ngIf="showErrorMessage('max')">
            {{label}} cannot be more than {{max}}
        </ng-container>

        <ng-container *ngIf="showErrorMessage('precision')">
            {{label}} cannot have more than {{precision}} digits
        </ng-container>

        <ng-container *ngIf="showErrorMessage('scale')">
            {{label}} cannot have more than {{scale}} digits
        </ng-container>

        <ng-container *ngIf="helperTextSpacer"></ng-container>

        <ng-container *ngIf="hasCustomValidators">
            <ng-container *ngFor="let customError of customErrors">
                <ng-container *ngIf="showErrorMessage(customError.errorKey)">
                    {{customError.message}}
                </ng-container>
            </ng-container>
        </ng-container>
    </span>
</forge-text-field>